import React, { useMemo, useState } from "react";

//* Import Component
import PoolsStandings from "./PoolsStandings";

//* Import Stores
import { useDroppedNodeStore } from "../../../utilities/stores";

const onDragStart = (event, data) => {
  if (data.nodeType) {
    event.dataTransfer.setData("application/reactflow", data.nodeType);
    event.dataTransfer.effectAllowed = "move";
  } else {
    event.dataTransfer.setData("teamData", JSON.stringify(data));
  }
};

const getKey = (type, index) => `${type.value}-${index + 1}`;

const Sidebar = ({
  teamData,
  gameNumbers,
  allTeams,
  division,
  poolsStandings = [],
}) => {
  const { droppedNodes } = useDroppedNodeStore();
  const [selectValue, setSelectValue] = useState("division");
  const [searchValue, setSearchValue] = useState("");

  const teamsCount = useMemo(() => {
    return Object.keys(allTeams).length || 0;
  }, [allTeams]);

  const typeData = useMemo(() => {
    let data = teamData.find((item) => item.value === selectValue);

    if (selectValue == "pool") {
      const records = teamData.filter((item) => item.value.includes("pool"));
      return records.reduce((result, data) => {
        if (data.maxTeams) {
          const teamsArray = Array.from({ length: data.maxTeams }).map(
            (_, index) => ({
              type: data.value,
              key: getKey(data, index),
              value: index + 1,
              label: `${data.label} ${index + 1}`,
            })
          );

          return result.concat(teamsArray);
        }
        return result;
      }, []);
    }

    if (!data) {
      return [];
    }

    if (selectValue === "winner" || selectValue === "loser") {
      return gameNumbers.map((game) => ({
        type: data.value,
        key: `${data.value}-${game}`,
        value: game,
        label: `${data.label}${game}`,
      }));
    }

    if (selectValue === "team") {
      return Object.entries(allTeams).map(([key, team]) => ({
        type: data.value,
        key: `team-${key}`,
        value: key,
        label: team,
      }));
    }

    if (data.maxTeams) {
      return Array.from({ length: data.maxTeams }).map((_, index) => ({
        type: data.value,
        key: getKey(data, index),
        value: index + 1,
        label: `${data.label} ${index + 1}`,
      }));
    }

    return [];
  }, [selectValue, gameNumbers, teamData]);

  const filteredTypeData = typeData.filter((type) =>
    type.label.toLowerCase().includes(searchValue.toLowerCase())
  );

  const isCompact = ["division", "overall", "winner", "loser"];

  return (
    <div className="col-md-2 selectTeams">
      <div className="dropdownSearch">
        <select
          name="sideTeam"
          id="sideTeam"
          className="form-control roundedSelect"
          onChange={(e) => setSelectValue(e.target.value)}
        >
          <option value="division">Division</option>
          {division && (
            <option value="pool">Pool ({poolsStandings.length})</option>
          )}
          <option value="overall">Overall Place</option>
          <option value="winner">Winner</option>
          <option value="loser">Loser</option>
          {division && <option value="team">Team ({teamsCount})</option>}
        </select>
        {!["division", "overall", "winner", "loser"].includes(selectValue) && (
          <input
            type="text"
            className="form-control roundedSelect mt-2"
            placeholder="Search text"
            onChange={(e) => setSearchValue(e.target.value)}
          />
        )}
      </div>

      <aside className="nodeAside">
        {selectValue == "pool" && <PoolsStandings pools={poolsStandings} />}

        <div className={isCompact.includes(selectValue) ? "boxes" : ""}>
          {filteredTypeData.map((type) => (
            <div
              key={type.key}
              className={`react-flow__node-default ${
                droppedNodes.includes(type.key) ? "droppedNode" : ""
              }`}
              onDragStart={(event) =>
                onDragStart(event, {
                  type: type.type,
                  label: type.label,
                  value: type.value,
                })
              }
              draggable
            >
              {isCompact.includes(selectValue) ? type.value : type.label}
            </div>
          ))}
        </div>
      </aside>
    </div>
  );
};

export default Sidebar;
